import React, {useContext} from 'react';
import { Navigate } from "react-router-dom";
import AuthContext from '../context/AuthContext';

function Protected({ children }) {
    const {user, loading} = useContext(AuthContext);

    if (loading) {
        return <div>Loading...</div>;
    }

    if (!user) {
        return <Navigate to="/login" />;
    }

    return children;
}
export default Protected;
